import {
	SET_LESSONS_TOTAL_TIME_PRACTICED,
	SET_LESSONS_TIME_PRACTICED,
	SET_STUDYSET_TIME_PRACTICED,
	SET_AVG_PRACTICE_TIME,
	SET_ACTIVE_STUDENTS,
	SET_EPS,
	SET_WEEKLY_ACTIVE_STUDENTS,
	RESET_EPS,
	SET_AVG_ELSA_SCORE,
	SET_PENTAGON,
	SET_DISTRIBUTION_EPS,
	SET_DISTRIBUTION_IELTS,
	SET_INDIVIDUAL_LEADERBOARD,
	SET_TEAM_LEADERBOARD,
	SET_BRANCH_LEADERBOARD,
	ADD_INDIVIDUAL_LEADERBOARD,
	ADD_TEAM_LEADERBOARD,
	ADD_BRANCH_LEADERBOARD,
	LESS_INDIVIDUAL_LEADERBOARD,
	HIDE_TEAM_LEADERBOARD,
	HIDE_BRANCH_LEADERBOARD,
	SET_AVERAGE_SCORE_SKILLS,
	RESET_LESSONS_TOTAL_TIME_PRACTICED,
	RESET_LESSONS_TIME_PRACTICED,
	RESET_STUDYSET_TIME_PRACTICED,
	RESET_AVG_PRACTICE_TIME,
	RESET_ACTIVE_STUDENTS,
	RESET_WEEKLY_ACTIVE_STUDENTS,
	RESET_INDIVIDUAL_LEADERBOARD,
	RESET_TEAM_LEADERBOARD,
	RESET_BRANCH_LEADERBOARD,
	RESET_SUM_ACTIVE_STUDENTS,
} from '../constants';
import { compose, pathOr, lensProp, view, propEq, when, isEmpty, always, map, sum } from 'ramda';
import { lensMatching } from '@/utils/ramda-utils';
import { retryableFetch } from '@/utils/apiReportutils';

const lensByName = compose(lensMatching, propEq('name'));

const state = {
	// Chart data for number of lesson and total time practiced
	lessonsTotalTimePracticed: {},
	// Chart data for number of lessons practiced
	lessonsTimePracticed: {},
	// Chart data for number of study-set practiced
	studySetTimePracticed: {},
	// Chart data for average lessons practice days
	// avgPracticeLessons: [],
	// Chart data for average practice time days
	avgPracticeTime: [],
	// Chart data for active students
	activeStudents: [],
	// Chart data for average eps
	avgProgress: [],
	// Chart data for Progress Chart (EPS)
	eps: [],

	overviewData: {},
	prevOverviewData: {},
	sumActiveStudents: null,

	weeklyActiveStudents: [],
	// Chart data for Average ELSA Score
	avgElsaScore: [],
	pentagon: {
		listening: 0,
		word_stress: 0,
		intonation: 0,
		fluency: 0,
		pronunciation: 0
	},
	distributionEps: null,
	distributionIelts: null,
	highestAverageScoreSkills: [],
	lowestAverageScoreSkills: [],
	leaderboardIndividual: null,
	leaderboardTeam: null,
	leaderboardBranch: null,
};

const mutations = {
	[SET_LESSONS_TOTAL_TIME_PRACTICED](state, lessonsTotalTimePracticed) {
		state.lessonsTotalTimePracticed = { ...lessonsTotalTimePracticed };
		const numberOfLessons = sum(lessonsTotalTimePracticed.numberOfLessons);
		const numberOfMinutes = sum(lessonsTotalTimePracticed.numberOfMinutes);
		const dayDiff = lessonsTotalTimePracticed.numberOfLessons.length
		let overviewData = {
			"lessons_count": numberOfLessons,
			"hours": numberOfMinutes / 60,
			"lessons_per_day": numberOfLessons/dayDiff,
			"minutes_per_day": numberOfMinutes/dayDiff
		};
		state.overviewData = {...overviewData};
	},
	[SET_LESSONS_TIME_PRACTICED](state, lessonsTimePracticed) {
		state.lessonsTimePracticed = { ...lessonsTimePracticed };
	},
	[SET_STUDYSET_TIME_PRACTICED](state, studySetTimePracticed) {
		state.studySetTimePracticed = { ...studySetTimePracticed };
	},
	[RESET_LESSONS_TOTAL_TIME_PRACTICED](state) {
		state.lessonsTotalTimePracticed = {};
	},
	[RESET_LESSONS_TIME_PRACTICED](state) {
		state.lessonsTimePracticed = {};
	},
	[RESET_STUDYSET_TIME_PRACTICED](state) {
		state.studySetTimePracticed = {};
	},
	[SET_AVG_PRACTICE_TIME](state, avgPracticeTime) {
		state.avgPracticeTime = { ...avgPracticeTime };
	},
	[RESET_AVG_PRACTICE_TIME](state) {
		state.avgPracticeTime = {};
	},
	[SET_ACTIVE_STUDENTS](state, activeStudents) {
		state.activeStudents = [ ...activeStudents ];
	},
	[RESET_ACTIVE_STUDENTS](state) {
		state.activeStudents = [];
	},
	[SET_WEEKLY_ACTIVE_STUDENTS](state, weeklyActiveStudents) {
		state.weeklyActiveStudents = [ ...weeklyActiveStudents ];
	},
	[RESET_WEEKLY_ACTIVE_STUDENTS](state) {
		state.weeklyActiveStudents = [];
	},
	[RESET_SUM_ACTIVE_STUDENTS](state) {
		state.sumActiveStudents = null;
	},
	[SET_EPS](state, [ eps = {} ] = []) {
		let cumulativeEps = 0;

		const normalizedEps = map((epsValue) => {
			if (!epsValue) return cumulativeEps;

			return (cumulativeEps = epsValue);
		})(eps.data);

		state.eps = [ { ...eps, data: normalizedEps } ];
	},
	[RESET_EPS](state) {
		state.eps = [];
	},
	[SET_AVG_ELSA_SCORE](state, [ avgElsaScore = {} ] = []) {
		let avg = [ 0 ];
		if (avgElsaScore.data) {
			let score = avgElsaScore.data;
			score = (Math.round(score * 100) / 100).toFixed(0);
			avg = [ score ];
		}
		state.avgElsaScore = avg;
	},
	[SET_DISTRIBUTION_EPS](state, distributionEps) {
		state.distributionEps = distributionEps;
	},
	[SET_DISTRIBUTION_IELTS](state, distributionIelts) {
		state.distributionIelts = distributionIelts;
	},
	[SET_INDIVIDUAL_LEADERBOARD](state, leaderboardIndividual) {
		state.leaderboardIndividual = leaderboardIndividual;
	},
	[SET_TEAM_LEADERBOARD](state, leaderboardTeam) {
		state.leaderboardTeam = leaderboardTeam;
	},
	[SET_BRANCH_LEADERBOARD](state, leaderboardBranch) {
		state.leaderboardBranch = leaderboardBranch;
	},
	[ADD_INDIVIDUAL_LEADERBOARD](state, leaderboardIndividual) {
		state.leaderboardIndividual = state.leaderboardIndividual.concat(leaderboardIndividual);
	},
	[ADD_TEAM_LEADERBOARD](state, leaderboardTeam) {
		state.leaderboardTeam = state.leaderboardTeam.concat(leaderboardTeam);
	},
	[ADD_BRANCH_LEADERBOARD](state, leaderboardBranch) {
		state.leaderboardBranch = state.leaderboardBranch.concat(leaderboardBranch);
	},
	[LESS_INDIVIDUAL_LEADERBOARD](state, {page: page, page_size: page_size} = {}) {
		
		state.leaderboardIndividual = state.leaderboardIndividual.concat();
		
		if (state.leaderboardIndividual == null) {
			return;
		}
		state.leaderboardIndividual = state.leaderboardIndividual.slice(0, (page + 1) * page_size);
	},
	[HIDE_TEAM_LEADERBOARD](state) {
		if (state.leaderboardTeam == null) {
			return;
		}
		const currentLeaderboard = state.leaderboardTeam;
		const length = currentLeaderboard.length >= 5 ? 5 : currentLeaderboard.length;
		state.leaderboardTeam = [];
		// get only first 5 item
		for (let i = 0; i < length; i++) {
			state.leaderboardTeam.push(currentLeaderboard[i]);
		}
	},
	[HIDE_BRANCH_LEADERBOARD](state) {
		if (state.leaderboardBranch == null) {
			return;
		}
		const currentLeaderboard = state.leaderboardBranch;
		const length = currentLeaderboard.length >= 5 ? 5 : currentLeaderboard.length;
		state.leaderboardBranch = [];
		// get only first 5 item
		for (let i = 0; i < length; i++) {
			state.leaderboardBranch.push(currentLeaderboard[i]);
		}
	},
	[RESET_INDIVIDUAL_LEADERBOARD](state) {
		state.leaderboardIndividual = [];
	},
	[RESET_TEAM_LEADERBOARD](state) {
		state.leaderboardTeam = [];
	},
	[RESET_BRANCH_LEADERBOARD](state) {
		state.leaderboardBranch = [];
	},
	[SET_PENTAGON](state, pentagon) {
		state.pentagon = pentagon;
	},
	[SET_AVERAGE_SCORE_SKILLS](state, averageScoreSkills) {
		{
			var items = [];

			Object.keys(averageScoreSkills).forEach(function(key) {
				if (averageScoreSkills[key] >= 78) {
					items.push({ name: key, data: [ averageScoreSkills[key] ] });
				}
			});

			items.sort(function(first, second) {
				return second.data[0] - first.data[0];
			});

			state.highestAverageScoreSkills = items.slice(0, 5);
		}

		{
			items = [];
			Object.keys(averageScoreSkills).forEach(function(key) {
				if (averageScoreSkills[key] < 78) {
					items.push({ name: key, data: [ averageScoreSkills[key] ] });
				}
			});

			items.sort(function(first, second) {
				return first.data[0] - second.data[0];
			});

			state.lowestAverageScoreSkills = items.slice(0, 5);
		}
	}
};

const actions = {
	resetEpsChart({ commit }) {
		commit(RESET_EPS);
	},
	resetLessonStudysetPracticeChart({ commit }) {
		commit(RESET_LESSONS_TOTAL_TIME_PRACTICED);
		commit(RESET_LESSONS_TIME_PRACTICED);
		commit(RESET_STUDYSET_TIME_PRACTICED);
		commit(RESET_SUM_ACTIVE_STUDENTS);
	},
	resetAvgPracticeTimeChart({ commit }) {
		commit(RESET_AVG_PRACTICE_TIME);
	},
	resetActiveStudentChart({ commit }) {
		commit(RESET_ACTIVE_STUDENTS);
	},
	resetWeeklyStudentChart({ commit }) {
		commit(RESET_WEEKLY_ACTIVE_STUDENTS);
	},
	resetIndividualLeaderboard({commit}) {
		commit(RESET_INDIVIDUAL_LEADERBOARD);
	},
	resetTeamLeaderboard({commit}) {
		commit(RESET_TEAM_LEADERBOARD);
	},
	resetBranchLeaderboard({commit}) {
		commit(RESET_BRANCH_LEADERBOARD);
	},
};
// eslint-disable-next-line no-unused-vars
export function getAbstractDummyGetChartData({ commit, mutationId, from, to, name }) {
	return Promise.resolve({ data: [] }).then((response) => {
		const chartData = compose(pathOr([], [ 'data' ]))(response);

		return commit(mutationId, chartData);
	});
}

export function getAbstractGetChartData({ axios, commit, mutationId, url, from, to, name, scope, sort_by, order_by, page }) {
	const processResponse = (response) => {
		const chartData = compose(when(isEmpty, always([ { name, data: [] } ])), pathOr([ { name, data: [] } ], [ 'data' ]))(response);
		return commit(mutationId, chartData);
	}
	const params = { from, to, scope, sort_by, order_by, page };
	return retryableFetch({axios, url, params, processResponse});
}

export function getAbstractGetChartDataWithoutEmptyGuard({ axios, commit, mutationId, url, from, to, name, scope, sort_by, order_by, page, page_size }) {
	return axios.get(url, { params: { from, to, scope, sort_by, order_by, page, page_size } }).then((response) => {
		const chartData = pathOr([ { name, data: [] } ], [ 'data' ])(response);
		return commit(mutationId, chartData);
	});
}

// eslint-disable-next-line no-unused-vars
export function getDummyAbstractLessonsPracticed({ commit, mutationId, from, to }) {
	return Promise.resolve({
		data: [
			{
				name: 'number_of_lessons',
				data: []
			},
			{
				name: 'number_of_minutes',
				data: []
			}
		]
	}).then((response) => {
		const numberOfLessons = view(compose(lensProp([ 'data' ]), lensByName('number_of_lessons'), lensProp('data')))(response);
		const numberOfMinutes = view(compose(lensProp([ 'data' ]), lensByName('number_of_minutes'), lensProp('data')))(response);

		return commit(mutationId, {
			numberOfLessons,
			numberOfMinutes
		});
	});
}
// Utility functions specific to these modules
const sec2minute = (sec) => sec / 60;
const getNumberOfLessons = (response) => view(compose(lensProp([ 'data' ]), lensByName('number_of_lessons'), lensProp('data')))(response);
const getNumberOfMinutes = (response) => map(sec2minute, view(compose(lensProp([ 'data' ]), lensByName('number_of_seconds'), lensProp('data')))(response));
const getAvgPracticeTime = (response) => view(compose(lensProp([ 'data' ]), lensByName('avg_practice_time'), lensProp('data')))(response);
const getAvgPracticePerday = (response) => view(compose(lensProp([ 'data' ]), lensByName('avg_practice_time_perday'), lensProp('data')))(response);

export async function getAbstractLessonsPracticed({ axios, commit, mutationId, url, from, to, scope }) {
	const processResponse = (response) => {
		const numberOfLessons = getNumberOfLessons(response);
        const numberOfMinutes = getNumberOfMinutes(response);
        return commit(mutationId, { numberOfLessons, numberOfMinutes });
	}
	const params = { from, to, scope };
	return retryableFetch({axios, url, params, processResponse});
}

export function getAbstractStudySetsPracticed({ axios, commit, mutationId, url, from, to, scope }) {
	return axios.get(url, { params: { from, to, scope } }).then((response) => {
		const sec2minute = (sec) => sec / 60;
		const numberOfLessons = view(compose(lensProp([ 'data' ]), lensByName('number_of_studysets'), lensProp('data')))(response);
		const numberOfMinutes = map(sec2minute, view(compose(lensProp([ 'data' ]), lensByName('number_of_seconds'), lensProp('data')))(response));
		return commit(mutationId, {
			numberOfLessons,
			numberOfMinutes
		});
	});
}

export async function getAbstractAvgPracticeTime({ axios, commit, mutationId, url, from, to, scope }) {
	const processResponse = (response) => {
		const avgPracticeTime = getAvgPracticeTime(response);
        const avgPracticePerday = getAvgPracticePerday(response);
        return commit(mutationId, { avgPracticeTime, avgPracticePerday });
	}
	const params = { from, to, scope };
	return retryableFetch({axios, url, params, processResponse});
}

export default {
	state,
	mutations,
	actions
};
